import { render, staticRenderFns } from "./ViewEmailModal.vue?vue&type=template&id=6bd45483&"
import script from "./ViewEmailModal.vue?vue&type=script&lang=js&"
export * from "./ViewEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports